import { render } from "./TaskCard.vue?vue&type=template&id=5c60a443&scoped=true"
import script from "./TaskCard.vue?vue&type=script&lang=js"
export * from "./TaskCard.vue?vue&type=script&lang=js"

import "./TaskCard.vue?vue&type=style&index=0&id=5c60a443&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-5c60a443"

export default script